export enum DeleteModalType {
  Delete = 'delete',
  Unassign = 'unassign',
}
